($ => {
  let api
  
  // $(() => {
  //   $('nav.breadcrumbs-container').insertBefore($('#product-builder'))
  // })

  function getProductDetails() {
    const product = CPB.getStore().getState().Product
    let details = {panels: []}
    product.panels.forEach(panel => {
      let panelOjb = {
        title: panel.title,
        categories: []
      }
      const panelLayers = product.layers.filter(layer => layer.panel === panel.id)
      if(panelLayers.length === 0) return
      panel.categories.forEach(category => {
        let categoryObj = {
          title: category.title,
          options: [],
          categoryObj: category,
        }
        const categoryLayers = panelLayers.filter(layer => layer.category === category.id)
        if(categoryLayers.length === 0) return
        category.options.forEach(option => {
          const optionLayer = categoryLayers.find(layer => layer.option === option.id)
          if(!optionLayer) return
          const value = (category.type === 'input' || category.type === 'inputLong') ? optionLayer.value : option.option.data.label
          categoryObj.options.push({
            value,
            sku: option.sku,
            optionObj: option
          })
        })
        if(categoryObj.options.length) panelOjb.categories.push(categoryObj)
      })
      if(panelOjb.categories.length) details.panels.push(panelOjb)
    })
    return details
  }

  function isProductComplete() {
    const categoryTypesToIgnore = ['calculateFields']
    const product = CPB.getStore().getState().Product
    let requiredNotSelectedCategories = []
    product.panels.forEach(panel => {
      if(api.checkLogic(panel) === false) return
      requiredNotSelectedCategories = requiredNotSelectedCategories.concat(panel.categories.filter(category => {
        if(category.required && !product.layers.find(layer => layer.category === category.id) && api.checkLogic(category)) {
          if(categoryTypesToIgnore.includes(category.type)) return
          requiredNotSelectedCategories.push(category)
        }
      }))
    })
    return !requiredNotSelectedCategories.length;
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i")
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2')
    } else {
        var hash = ''
        if(uri.indexOf('#') !== -1 ){
            hash = uri.replace(/.*#/, '#')
            uri = uri.replace(/#.*/, '')
        }
    
        var separator = uri.indexOf('?') !== -1 ? "&" : "?"
        return uri + separator + key + "=" + value + hash;
    }
  }
  
  var getProductConfigUrl = async function() {
      var configId = await window._cpb.saveConfig(null, false)
      return updateQueryStringParameter(window.location.href, 'configid', configId)
  }

  function addToQuoteInit() {
    const addToCartBtn = $('.cpb-add-to-cart-button')
    const productForm = $('form[data-product-form]')
    const addToQuoteBtn = productForm.find('button[onclick*="GRFQApp.addProduct"]')
    if(addToQuoteBtn.length === 0) return
    
    addToCartBtn.css({
      display: 'none',
      visibility: 'hidden',
      pointerEvents: 'none'
    })

    const customAddToCart = $('<button class="cpb-custom-add-to-cart btn">').text('Add to Quote')

    $('#product-builder').attr('data-cpb-custom-add-to-quote', true)

    customAddToCart.on('click', async () => {
      if(!isProductComplete()) {
        addToCartBtn.trigger('click')
        return
      }
      customAddToCart.attr('disabled', true)
      await addProductDetails()
      addToQuoteBtn.trigger('click')
      // setTimeout(() => {s
      //   debugger
      // }, 50)
    })

    addToCartBtn.after(customAddToCart)

    async function addProductDetails() {
      productForm.find('.cpb-custom-product-details-wrapper').remove()
      const wrapper = $('<div class="cpb-custom-product-details-wrapper">')
      const productDetails = getProductDetails()

      productForm.append(wrapper)
      
      productDetails.panels.forEach(panel => {
        panel.categories.forEach(category => {
          const propertyName = (panel.title + ' - ' + category.title)
          let propertyValue = ''
          category.options.forEach((option, i) => {
            if(i > 0) propertyValue += ', '
            propertyValue += option.value
            if(option.sku) propertyValue += ` [${option.sku}]`
          })
          const cleanName = encodeURIComponent(propertyName.replaceAll('"', '&quot;'))
          const cleanValue = encodeURIComponent(propertyValue.replaceAll('"', '&quot;'))      
          const input = $(`<input type="hidden" name="properties[${cleanName}]" value="${cleanValue}">`)

          wrapper.append(input)      
        })
      })
      
      const url = await getProductConfigUrl()
      const cleanValue = encodeURIComponent(`${url}&p${CPB.getStore().getState().Product.price}`)
      wrapper.append($(`<input type="hidden" name="properties[Configuration]" value="${cleanValue}">`))
      wrapper.append($(`<input type="hidden" name="properties[end]" value="1">`))
      return true
    }
  }

  function customAddToCart() {
    if (!!window._cpb.settings === false) window._cpb.settings = {}
    window._cpb.settings.addToCartOverride = async data => {
        console.log(data, 'data')
        if (data.items.length < 2) {
          fetch("/cart/add.js", {
              "headers": {
                  "content-type": "application/json;charset=UTF-8"
              },
              "body": JSON.stringify({
                  items: data.items
              }),
              "method": "POST"
          }).then(() => {
              if(data.redirect) location.href = '/cart'
          })
          return
        }
        let sourceQty;
        const targetIds = [];
        const productDetails = getProductDetails();
        let propKeeperItemId;
        
        const randomString = (i) => {
            var rnd = '';
            while (rnd.length < i)
                rnd += Math.random().toString(36).substring(2);
            return rnd.substring(0, i);
        };

        const bundleId = randomString(10);

        productDetails.panels.forEach(p => p.categories.forEach(c => {
          if (c.categoryObj.metafields && c.categoryObj.metafields.find(mf => mf.key == 'custom-multiplier')) {
            const value = c.categoryObj.metafields.find(mf => mf.key == 'custom-multiplier').value;
            if (value.includes('source-option')) {
              sourceQty = c.options.length;
            }
            if (value.includes('target-option')) {
              c.options.forEach(o => {
                if (o.optionObj.inventory) {
                  targetIds.push(o.optionObj.inventory.variant.toString());                  
                } else {
                  console.log(`The category '${c.title}' has option '${o.optionObj.option.data.label}', which isn't connected to any SKU!`)
                }
              })
            }
            if (value.includes('prop-keeper')) {
              c.options.forEach(o => {
                if (o.optionObj.inventory) {
                  propKeeperItemId = o.optionObj.inventory.variant.toString();             
                }
              })
            }
          }
        }))

        data.items.forEach((item, i, arr) => {
          if (!item.properties) item.properties = {};
          item.properties._bundleId = bundleId;
          item.properties._bundleIndex = arr.length - 1 - i;
          
          if (sourceQty && targetIds.includes(item.id.toString())) {
            item.quantity = sourceQty;
          }
          if (item.id.toString() == propKeeperItemId) {
            item.properties = Object.assign(item.properties, data.items.find(currItem => currItem.configid).properties);
            item.properties._bundleIndex = 0;
          }
          if (propKeeperItemId && item.configid) {
            item.quantity = 0;
          }
        });
        console.log(data);
        

        fetch("/cart/add.js", {
            "headers": {
                "content-type": "application/json;charset=UTF-8"
            },
            "body": JSON.stringify({
                items: data.items
            }),
            "method": "POST"
        }).then(() => {
            if(data.redirect) location.href = '/cart'
        })
    }
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    CPB.FrontendApi().then(API => api = new API)
    addToQuoteInit();
    customAddToCart();
  })
})(jQuery)